export enum RoundToMillionsType {
  DISABLED,
  ROUND,
  ROUNDDOWN,
}

export namespace RoundToMillionsType {
  let elements = [
    RoundToMillionsType.DISABLED,
    RoundToMillionsType.ROUND,
    RoundToMillionsType.ROUNDDOWN,
  ];
  let alias = "com.bcdfx.model.RoundToMillionsType";

  export function RemoteClass() {
    return alias;
  }

  export function getAllElements() {
    return elements;
  }
}
